import React, {useContext} from "react"
import MaterialIcon from "../../../../components-shared/material-icon/material-icon-view"
import styles from "../../progress-chart/progress-chart.module.scss"
import {Button} from "../../../../components-shared/button/button"
import {CategoryHelperContext} from "../../../../services/helpers/category-helper"

export interface SelectedCategoryPillProps {
  id: number
  onClick: () => void
}

export const SelectedCategoryPill : React.FC<SelectedCategoryPillProps> = ({ id, onClick }) => {
  const categoryHelper = useContext(CategoryHelperContext)
  if (categoryHelper === null) return null

  const category = categoryHelper.getCategoryName(id)
  const color = categoryHelper.mainColorById[id]

  return <Button buttonStyle="colorCode" buttonSize="xsmall" onClick={onClick} colorCode={color}>
    {category}
    <MaterialIcon name="delete" className={styles.RemoveIcon} size="small"/>
  </Button>
}